import { DocumentsInformation } from './agent/addProperty';

export interface EconomicInformation {
  cost: number;
  updatedCost: number;
  minCredit: number;
  minSalary: number;
  leaseConcession?: boolean;
  leaseMonthsFree?: string | number;
  leaseTerm?: string;
  netEffectiveRent?: number;
}

export interface Image {
  id: string;
  image: string;
  thumbnail?: string;
}

interface ExtraFee {
  name: string;
  amount: string;
  fee_type: string;
}

export interface chargeInformation {
  applicationFee?: number | null;
  brokerFee?: number | null;
  extraFee?: ExtraFee[];
  securityDeposit?: number | null;
}

export interface ImageInformation {
  images: Image[];
  rotation?: number;
}

export interface Amenity {
  type: string;
  included: boolean;
}

export interface AmenityInformation {
  amenities: Amenity[];
}

export interface Place {
  id: string;
  image: string | null | unknown;
  name: string | null;
  address: string | null;
  url?: string;
}
export interface PlaceInformation {
  places: Place[];
}

export interface Agent {
  id: string;
  generalInformation: {
    firstName: string;
    middleName: string;
    lastName: string;
    verified: boolean;
  };
  agentInformation: {
    profilePicture: string;
    companyName: string;
    bio: string;
    profileUrlIdentifier: string;
  };
}

export interface Collaborator {
  id: string;
  email: string;
  role: string;
  status: string;
  invitedAt: string;
  respondedAt: string | null;
  agentInfo: Agent;
}

export interface Coordinates {
  lat: number;
  lng: number;
}

export interface Address {
  coordinates: Coordinates;
  primary: string;
  neighborhood: string;
  state: string;
  country: string;
  postalCode: string;
  unitCode: string | null;
  route?: string;
  postal_code?: string;
}

export interface GeneralInformation {
  agent: Agent;
  address: Address;
  bedrooms: number;
  cost: number;
  bathrooms: number;
  squareFootage: number;
  propertyName: string;
  dateAvailable: string;
  description: string;
  timePosted: string;
  isEasyApply?: boolean;
  isOpen?: boolean;
  sevenDayExpiryDate?: string;
  sevenDayNonPaymentCycleStartDate?: string;
  nextPaymentDate?: string;
  isFreeThroughSubscription?: boolean;
  isExclusive?: boolean;
  isApplicationRequestEnabled?: boolean;
  collaboratorsList?: Collaborator[];
}

export interface StatisticInformation {
  applications: number;
  saves: number;
  views: number;
  submittedApplications?: number;
}

export interface DocumentInformation {
  plaidVerifiedFinancials: boolean;
  photoId: boolean;
  rentalHistory: boolean;
  employmentVerification: boolean;
  creditCheck: boolean;
  paystubs: boolean;
  w2Form: boolean;
  bankStatements: boolean;
  taxReturns: boolean;
}

export interface Property {
  id: string;
  generalInformation: GeneralInformation;
  imageInformation: ImageInformation;
  economicInformation: EconomicInformation;
  chargeInformation?: chargeInformation;
  statisticInformation?: StatisticInformation;
  isSave?: boolean;
  amountToBeCharged?: number;
  creationDate?: string;
  lastUpdate?: string;
}

export interface PropertyDetails {
  id: string;
  generalInformation: GeneralInformation;
  imageInformation: ImageInformation;
  economicInformation: EconomicInformation;
  statisticInformation: StatisticInformation;
  documentInformation: DocumentsInformation;
  amenityInformation: AmenityInformation;
  placeInformation: PlaceInformation;
  chargeInformation: chargeInformation;
  lastUpdate?: string;
  creationDate?: string;
  isSaved?: boolean;
}

export interface AllGetSavedProperty {
  id: number;
  creation_date: string;
  last_update: string;
  renter_id: string;
  property_id: string;
}

export interface PostSaveRenterSyncPayload {
  renter_id: string;
  property_ids: string[];
}

export interface DeleteUnsaveRenterSyncPayload {
  property_id: string;
}

export const SORT_MAP = {
  'Newest to Oldest': '-creation_date',
  'Oldest to Newest': 'creation_date',
  'Highest to Lowest Price': '-economic_information__cost',
  'Lowest to Highest Price': 'economic_information__cost',
};

export const SORT_FILTER_MAP = {
  '-creation_date': 'Newest to Oldest',
  creation_date: 'Oldest to Newest',
  '-economic_information__cost': 'Highest to Lowest Price',
  economic_information__cost: 'Lowest to Highest Price',
};
export type SortingOption =
  | 'Newest to Oldest'
  | 'Oldest to Newest'
  | 'Highest to Lowest Price'
  | 'Lowest to Highest Price';

export type SortFilter =
  | '-creation_date'
  | 'creation_date'
  | '-economic_information__cost'
  | 'economic_information__cost';
